import React from "react";
import CommentCard from "../cards/CommentCard";

// Style \\
import "../../assets/styles/sections/comment.scss";

import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Comment = () => {
  return (
    <section className="comment mb-16">
      <div className="comment_bg">
        <div className="containers">
          <div className="comment_items">
            <div className="comment_items_cardBox ">
              <Swiper
                className="swipperHead w-full "
                modules={[Navigation, Pagination, Scrollbar, A11y]}
                spaceBetween={60}
                slidesPerView={1}
                pagination={{ clickable: true }}
                onSlideChange={() => console.log("slide change")}
              >
                <SwiperSlide className="SwiperSlide w-full">
                  <CommentCard />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <CommentCard />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <CommentCard />
                </SwiperSlide>

                <div className="dot">...</div>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comment;
